import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useSendContractByEmail } from '../utils/hooks/useSendContractByEmail';

interface SendContractByEmailProps {
  contractId: string;
  action: ReactElement;
}

export const SendContractByEmail: FC<SendContractByEmailProps> = memo((props) => {
  const { contractId, action } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const { send, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useSendContractByEmail();

  const sendContract = useCallback(() => {
    send(contractId);
  }, [contractId, send]);

  return (
    <>
      {React.cloneElement(action, { onClick: openConfirmModal })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Send contract')}
        description={t('Are you sure you want to send contract?')}
        isLoading={isLoading}
        onOk={sendContract}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
